// replace image on change mats type inputs

document.addEventListener('DOMContentLoaded', function () {
  // Cache DOM elements
  const productContainer = document.querySelector('.product.config_container');
  const popupContainer = document.querySelector('.application_form__content.config_container');

  if (!productContainer && !popupContainer) return;

  // Initialize auto type
  let initialautoType, autoType;
  const productElement = document.querySelector('.product');
  
  if (productElement) {
    initialautoType = productElement.dataset.type;
    autoType = productElement.dataset.type;
  } else {
    autoType = '5os';
  }

  // Auto type normalization
  const basePath = "https://cdn.shopify.com/s/files/1/0734/7988/1010/files/";
  const typeMapping = {
    '7os': '5os', 'pickup': '5os', 'pickup2kabina': '5os', '2os': '5os',
    'van_maly': '5os', 'electro': '5os', 'custom': '5os', 'electro_7os': '5os',
    'van_duzy': 'VAN', 'camper': 'VAN', 'tractor': 'VAN', 'bus_solid': 'VAN',
    'van_duzy_solid': 'VAN', 'van_duzy_solid_2_row': 'VAN',
    'van_duzy_separate': 'bus', 'van_duzy_separate_2_row': 'bus',
    'minivan_mini': 'minivan'
  };
  autoType = typeMapping[autoType] || autoType;

  // Pattern class mapping
  const patternClassMap = {
    'romby': 'diamonds',
    'plastry miodu': 'honey',
    'krople': 'drop'
  };

  const typeCustomPrices = {
    noEdge: [450, 450, 710, 550, 910],
    withEdge: [550, 550, 910, 550, 1210]
  };

  // Get current options from container
  function getCurrentOptions(container) {
    const matTypeElement = container.querySelector('.product-form__input[data-name="mats_type"] input:checked');
    const matType = matTypeElement ? matTypeElement.dataset.name.toLowerCase().replace(/\s+/g, '-') : '';
    let matPattern = container.querySelector('.lip__field[data-type="matPattern"] input:checked')?.dataset.value;
    const matColor = container.querySelector('.lip__field[data-type="matColor"] input:checked')?.dataset.value;
    let edgeColor = container.querySelector('.lip__field[data-type="trimColor"] input:checked')?.dataset.value;
    
    if (matPattern !== 'drop') {
      if (edgeColor === 'darkblue') edgeColor = 'blue';
      else if (edgeColor === 'blue') edgeColor = 'darkblue';
    }
    
    return { matType, matPattern, matColor, edgeColor };
  }

  // Update mat image
  function updateMatImage(container) {
    let { matType, matPattern, matColor, edgeColor } = getCurrentOptions(container);
    if (autoType === 'tir' || autoType === 'bus') matPattern = 'diamonds';
    
    let imageUrl;
    if (container.classList.contains('application_form__content')) {
      imageUrl = document.body.classList.contains('template_zamowienie-indywidualne')
        ? `${basePath}corners-${matPattern}-${matColor}-${edgeColor}.webp`
        : `${basePath}5os-${matType ? matType + '-' : ''}${matPattern}-${matColor}-${edgeColor}.webp`;
    } else {
      imageUrl = `${basePath}${autoType}-${matType ? matType + '-' : ''}${matPattern}-${matColor}-${edgeColor}.webp`;
    }

    const selector = window.innerWidth > 990 
      ? '.product__config_image--desktop img' 
      : '.product__config_image--mobile_image';
    
    container.querySelectorAll(selector).forEach(img => img.src = imageUrl);
  }

  // Update lip title values
  const updateLipTitleValue = () => {
    // Update radio button fields
    document.querySelectorAll('.lip__field').forEach(field => {
      const inputChecked = field.querySelector('input:checked');
      if (!inputChecked) return;

      const value = inputChecked.dataset.title;
      const titleValueElement = field.querySelector('.lip__title_value');
      if (titleValueElement) titleValueElement.textContent = value;

      // Update properties
      const selectedRodzaj = document.querySelector('input[name="Rodzaj dywaników"]:checked');
      const selectedZestaw = document.querySelector('input[name="Zestaw"]:checked');
      const selectedRozmiar = document.querySelector('input[name="Rozmiar"]:checked');

      const rodzajProperty = document.querySelector('[name="properties[Rodzaj dywaników_]"]');
      const zestawProperty = document.querySelector('[name="properties[Zestaw_]"]');
      const rozmiarProperty = document.querySelector('[name="properties[Rozmiar_]"]');
      
      if (rodzajProperty && selectedRodzaj && selectedZestaw) {
        rodzajProperty.value = selectedRodzaj.value;
        zestawProperty.value = selectedZestaw.value;
      }
      if (rozmiarProperty && selectedRozmiar) {
        rozmiarProperty.value = selectedRozmiar.value;
      }

      // Handle custom type pricing
      if (initialautoType === 'custom' && selectedRodzaj && selectedZestaw) {
        const zestawField = document.querySelector('[data-name="Zestaw"]');
        const zestawValue = zestawField?.querySelector('input:checked')?.dataset.title;
        const rodzajValue = selectedRodzaj.dataset.title;
        const zestawIndex = Array.from(selectedZestaw.closest('fieldset').querySelectorAll('input')).indexOf(selectedZestaw);
        
        let price = null;
        if (rodzajValue === '3D BEZ RANTÓW') price = typeCustomPrices.noEdge[zestawIndex];
        else if (rodzajValue === '3D Z RANTAMI') price = typeCustomPrices.withEdge[zestawIndex];
        
        const zestawTitleValue = zestawField?.querySelector('.lip__title_value');
        if (zestawTitleValue && price !== null) {
          zestawTitleValue.textContent = `${zestawValue} ${price} zł`;
        }
      }
    });

    // Update select elements
    document.querySelectorAll('select').forEach(select => {
      if (!select.value) return;
      const fieldset = select.closest('fieldset');
      const titleValueElement = fieldset?.querySelector('.lip__title_value');
      if (titleValueElement) {
        titleValueElement.textContent = select.options[select.selectedIndex].text;
      }
    });

    // Update text inputs and textareas in .lip__field (Marka samochodu, Model samochodu, Pojazd, etc.)
    document.querySelectorAll('.lip__field input[type="text"], .lip__field textarea').forEach(input => {
      const field = input.closest('.lip__field');
      const titleValueEl = field?.querySelector('.lip__title_value');
      if (titleValueEl) titleValueEl.textContent = input.value.trim();
    });
  };

  // Handle pattern change
  function handlePatternChange(input, parentContainer) {
    const patternClass = patternClassMap[input.value];
    if (!patternClass) return;

    const matColorField = parentContainer.querySelector('.lip__field[data-type="matColor"]');
    if (!matColorField) return;

    // Update active classes
    ['honey_active', 'diamonds_active', 'drop_active'].forEach(cls => 
      matColorField.classList.remove(cls)
    );
    matColorField.classList.add(`${patternClass}_active`);

    // Check and reset if current color doesn't match pattern
    const currentCheckedInput = matColorField.querySelector('input:checked');
    if (currentCheckedInput) {
      const currentItem = currentCheckedInput.closest('.lip__item');
      if (!currentItem.classList.contains(patternClass)) {
        currentCheckedInput.checked = false;
        currentCheckedInput = null;
      }
    }

    // Select first valid option if none selected
    if (!matColorField.querySelector('input:checked')) {
      const firstVisibleInput = matColorField.querySelector(`.lip__item.${patternClass} input[type="radio"]`);
      if (firstVisibleInput) {
        firstVisibleInput.checked = true;
        updateSelectedValueText(parentContainer);
      }
    }
  }

  // EVENT DELEGATION - Single event listener instead of hundreds
  document.addEventListener('change', (e) => {
    const target = e.target;
    
    // Handle radio buttons
    if (target.type === 'radio' && 
        (target.closest('.product-form__input') || target.closest('.lip__field'))) {
      
      const parentContainer = target.closest('.config_container');
      if (!parentContainer) return;
      
      if (target.closest('.product-form__input[data-name="mats_type"]') ||
          target.closest('.product-form__input[data-name="mats_set"]') ||
          target.closest('.lip__field[data-type="matColor"]') ||
          target.closest('.lip__field[data-type="trimColor"]')) {
        updateSelectedValueText(parentContainer);
      }

      if (target.closest('.lip__field[data-type="matPattern"]')) {
        handlePatternChange(target, parentContainer);
      }

      updateMatImage(parentContainer);
      updateLipTitleValue();
    }
    
    // Handle select elements
    if (target.tagName === 'SELECT') {
      updateLipTitleValue();
    }

    // Handle text inputs and textareas in .lip__field (Marka/Model samochodu, Pojazd)
    if (target.matches('input[type="text"], textarea') && target.closest('.lip__field')) {
      updateLipTitleValue();
    }
  }, true); // Use capture phase for better performance

  // Live update .lip__title_value while typing in text fields
  document.addEventListener('input', (e) => {
    if (e.target.matches('input[type="text"], textarea') && e.target.closest('.lip__field')) {
      updateLipTitleValue();
    }
  }, true);

  // Initialize
  [productContainer, popupContainer].forEach(container => {
    if (container) {
      updateMatImage(container);
      restoreMatPattern(container);
    }
  });
  updateLipTitleValue();

  // Restore mat pattern on page load/back
  function restoreMatPattern(container) {
    if (!container) return;

    setTimeout(() => {
      const checkedPattern = container.querySelector('.lip__field[data-type="matPattern"] input:checked');
      if (!checkedPattern) return;

      const patternClass = patternClassMap[checkedPattern.value];
      if (!patternClass) return;

      const matColorField = container.querySelector('.lip__field[data-type="matColor"]');
      if (!matColorField) return;

      ['honey_active', 'diamonds_active', 'drop_active'].forEach(cls => 
        matColorField.classList.remove(cls)
      );
      matColorField.classList.add(`${patternClass}_active`);

      const checkedColor = matColorField.querySelector('input[type="radio"]:checked');
      if (checkedColor && !checkedColor.closest('.lip__item').classList.contains(patternClass)) {
        checkedColor.checked = false;
      }

      if (!matColorField.querySelector('input[type="radio"]:checked')) {
        const firstValid = matColorField.querySelector(`.lip__item.${patternClass} input[type="radio"]`);
        if (firstValid) firstValid.checked = true;
      }

      updateSelectedValueText(container);
      updateMatImage(container);
      updateLipTitleValue();
    }, 50);
  }

  // Page show event
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    [productContainer, popupContainer].forEach(container => {
      if (container) restoreMatPattern(container);
    });
  });

  // Update selected value text for mobile
  function updateSelectedValueText(container) {
    if (window.innerWidth >= 990) return;

    const fields = [
      { selector: '.product-form__input[data-name="mats_type"]', displaySelector: '[data-name="mats_type"]', type: 'input' },
      { selector: '.product-form__input[data-name="mats_set"]', displaySelector: '[data-name="mats_set"]', type: 'input' },
      { selector: '.lip__field[data-type="matColor"]', displaySelector: '[data-type="matColor"]', type: 'color' },
      { selector: '.lip__field[data-type="trimColor"]', displaySelector: '[data-type="trimColor"]', type: 'color' }
    ];

    fields.forEach(({ selector, displaySelector, type }) => {
      const input = container.querySelector(`${selector} input:checked`);
      if (!input) return;

      const value = input.dataset.title || input.value;
      const fieldset = container.querySelector(selector);
      const titleElement = fieldset?.querySelector('.lip__title');
      const title = titleElement?.firstChild.textContent.trim() || '';
      const display = container.querySelector(`.product__config_image_selected_value${displaySelector}`);
      
      if (display) {
        let html = title ? `${title}: <span>${value}</span>` : `<span>${value}</span>`;
        if (type === 'color' && input.nextElementSibling?.src) {
          html += ` <img src="${input.nextElementSibling.src}" alt=""/>`;
        }
        display.innerHTML = html;
      }
    });
  }

  if (productContainer) updateSelectedValueText(productContainer);
});

// Fixed config image for mobile - LAZY INITIALIZATION
let configImageInitialized = false;

function initConfigImage() {
  if (configImageInitialized) return;
  configImageInitialized = true;

  const configImage = document.querySelector('.product__config_image--main.product__config_image--mobile');
  const matPatternsColors = document.querySelector('[data-dropdown="mats_set_type"]');
  const matPatternsColorsAdditional = document.querySelector('[data-dropdown="mat_patterns_colors"]');
  
  if (!configImage || (!matPatternsColors && !matPatternsColorsAdditional)) return;

  let isFirst = matPatternsColorsAdditional?.closest('.product__dropdown_wr') === document.querySelector('.product__dropdown_wr');

  function toggleVisibility() {
    if (window.innerWidth < 990) {
      configImage.classList.add('is-fixed');
      const isDropdownOpen = (matPatternsColors?.classList.contains('open')) ||
                            (matPatternsColorsAdditional?.classList.contains('open') && !isFirst);
      configImage.classList.toggle('fixed_hidden', !isDropdownOpen);
    } else {
      configImage.classList.remove('is-fixed', 'fixed_hidden');
    }
  }

  toggleVisibility();

  if (isFirst) {
    let counter = 0;
    window.addEventListener('scroll', () => {
      if (counter > 0) return;
      const distance = matPatternsColors?.getBoundingClientRect().top;
      if (distance <= 200) {
        isFirst = false;
        toggleVisibility();
        counter++;
      }
    }, { passive: true });
  }

  window.addEventListener('resize', toggleVisibility, { passive: true });

  // EVENT DELEGATION for buttons
  document.addEventListener('click', (e) => {
    if (e.target.closest('.product__dropdown_button')) {
      setTimeout(toggleVisibility, 500);
    }
    if (e.target.closest('.product__config_image_remove_fixed')) {
      configImage.classList.toggle('fixed_hidden');
    }
  }, true);

  // Mutation observers
  [matPatternsColors, matPatternsColorsAdditional].forEach(element => {
    if (!element) return;
    new MutationObserver(toggleVisibility).observe(element, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
}

// Initialize only when needed (on first interaction or scroll)
if (window.innerWidth < 990) {
  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      initConfigImage();
      observer.disconnect();
    }
  }, { rootMargin: '100px' });
  
  const target = document.querySelector('.product__config_image--main');
  if (target) observer.observe(target);
}

// Config steps - OPTIMIZED with event delegation
(() => {
  var formContainers = document.querySelectorAll('.config_container');
  if (formContainers.length === 0) {
    formContainers = Array.from(document.querySelectorAll('.product')).filter(function (p) {
      return p.querySelector('.product__dropdown_wr');
    });
  }
  if (formContainers.length === 0) return;
  console.log('[product-config] formContainers:', formContainers.length);

  formContainers.forEach(container => {
    if (!container.querySelector('.product__dropdown_wr')) return;

    container.querySelectorAll('fieldset .error-message').forEach(el => el.style.display = 'none');

    const faqWrappers = container.querySelectorAll('.product__dropdown_wr');

    function triggerFaq(element) {
      const wrapper = element.closest('.product__dropdown_wr');
      const inner = wrapper.querySelector('.product__dropdown_inner');

      faqWrappers.forEach(w => {
        if (w === wrapper) return;
        w.classList.remove('open');
        const innerOther = w.querySelector('.product__dropdown_inner');
        innerOther.classList.remove('open');
        if (innerOther.classList.contains('super_done')) {
          innerOther.classList.add('done');
        }
      });

      const isOpen = wrapper.classList.toggle('open');
      inner.classList.toggle('open', isOpen);
      inner.classList.toggle('done', !isOpen && inner.classList.contains('super_done'));
    }

    function validateStep(wrapper, showErrors = false) {
      let stepValid = true;
      const processedRadioGroups = new Set();
      const requiredElements = wrapper.querySelectorAll('input[required], select[required], textarea[required]');
      if (showErrors) console.log('[product-config] validateStep showErrors=true, requiredElements:', requiredElements.length);

      requiredElements.forEach(element => {
        if (!showErrors && !element.offsetParent) return;
        if (showErrors && !element.offsetParent) console.log('[product-config] element no offsetParent:', element.tagName, element.name || element.id);
        let valid = true;

        if (element.type === 'radio') {
          if (processedRadioGroups.has(element.name)) return;
          processedRadioGroups.add(element.name);
          valid = [...wrapper.querySelectorAll(`input[type="radio"][name="${element.name}"]`)]
            .some(radio => radio.checked);
        } else if (element.type === 'checkbox') {
          valid = element.checked;
        } else {
          valid = element.value.trim() !== '';
        }

        const fieldset = element.closest('fieldset');
        const errorMessage = fieldset ? fieldset.querySelector('.error-message') : null;
        if (showErrors) console.log('[product-config] el', element.tagName, element.name || element.id, 'valid=', valid, 'fieldset=', !!fieldset, 'errorMessage=', !!errorMessage);
        if (errorMessage) {
          if (showErrors) {
            errorMessage.style.setProperty('display', !valid ? 'block' : 'none', 'important');
            if (showErrors) console.log('[product-config] set errorMessage.display =', !valid ? 'block' : 'none');
          } else if (valid) {
            errorMessage.style.setProperty('display', 'none', 'important');
          }
        }
        if (!valid) stepValid = false;
      });
      if (showErrors) console.log('[product-config] validateStep result stepValid=', stepValid);
      return stepValid;
    }

    function updateContinueButton(wrapper) {
      const continueBtn = wrapper.querySelector('.product__dropdown_button');
      if (!continueBtn) return;

      const isValid = validateStep(wrapper, false);
      // Не ставим disabled — иначе клик по кнопке не вызывает click, и error-message не показывается
      continueBtn.removeAttribute('disabled');
      continueBtn.classList.toggle('disabled-button', !isValid);
      continueBtn.setAttribute('aria-disabled', !isValid);
    }

    function revalidate(wrapper) {
      const inner = wrapper.querySelector('.product__dropdown_inner');
      const isValid = validateStep(wrapper, false);

      if (!isValid) {
        inner.classList.remove('super_done');
        wrapper.classList.remove('complete');
        setFollowingStepsDisabled(wrapper, true);
      }

      updateContinueButton(wrapper);
      if (container.querySelector('.application_form__next_button')) {
        updateNextButtonState(container);
      }
    }

    // Initialize buttons
    faqWrappers.forEach(wrapper => updateContinueButton(wrapper));

    // EVENT DELEGATION for all interactions
    container.addEventListener('input', (e) => {
      const wrapper = e.target.closest('.product__dropdown_wr');
      if (wrapper && e.target.matches('input[required], select[required], textarea[required]')) {
        revalidate(wrapper);
      }
    }, true);

    container.addEventListener('change', (e) => {
      const wrapper = e.target.closest('.product__dropdown_wr');
      if (wrapper && e.target.matches('input[required], select[required], textarea[required]')) {
        revalidate(wrapper);
      }
    }, true);

    container.addEventListener('click', (e) => {
      // Handle dropdown title clicks
      if (e.target.closest('.product__dropdown_title')) {
        triggerFaq(e.target.closest('.product__dropdown_title'));
        return;
      }

      // Handle continue button clicks
      const continueBtn = e.target.closest('.product__dropdown_button');
      if (continueBtn) {
        const wrapper = continueBtn.closest('.product__dropdown_wr');
        const inner = wrapper && wrapper.querySelector('.product__dropdown_inner');
        console.log('[product-config] click Dalej, wrapper=', !!wrapper, 'data-dropdown=', wrapper && wrapper.getAttribute('data-dropdown'));

        if (!wrapper || !inner) return;
        if (!validateStep(wrapper, true)) {
          updateContinueButton(wrapper);
          return;
        }

        wrapper.querySelectorAll('.error-message').forEach(el => el.style.display = 'none');
        wrapper.classList.remove('open');
        wrapper.classList.add('complete');
        inner.classList.remove('open');
        inner.classList.add('done', 'super_done');

        const nextWrapper = getNextDropdown(wrapper);
        if (nextWrapper) {
          nextWrapper.classList.add('open');
          nextWrapper.classList.remove('disabled');
          const nextInner = nextWrapper.querySelector('.product__dropdown_inner');
          nextInner.classList.add('open');
          nextInner.classList.remove('done');

          const nextTitle = nextWrapper.querySelector('.product__dropdown_title');
          const popup = document.querySelector('#popupOverlayApplicationForm');
          const isInsidePopup = wrapper.closest('.popup');

          setTimeout(() => {
            if (nextTitle) {
              if (isInsidePopup) {
                popup.scrollTo({ top: nextTitle.offsetTop - 20, behavior: 'smooth' });
              } else {
                window.scrollTo({
                  top: nextTitle.getBoundingClientRect().top + window.scrollY - 350,
                  behavior: 'smooth'
                });
              }
            }
          }, 500);
        }

        if (container.querySelector('.application_form__next_button')) {
          updateNextButtonState(container);
        }
      }
    }, true);

    function getNextDropdown(current) {
      let next = current.nextElementSibling;
      while (next) {
        if (next.classList.contains('product__dropdown_wr')) {
          next.classList.remove('disabled');
          return next;
        }
        next = next.nextElementSibling;
      }
      return null;
    }

    faqWrappers.forEach((wrapper, i) => {
      const title = wrapper.querySelector('.product__dropdown_title');
      title.innerHTML = `${i + 1}. ${title.innerHTML}`;
      if (i === 0) {
        wrapper.classList.add('open');
        wrapper.querySelector('.product__dropdown_inner').classList.add('open');
        wrapper.classList.remove('disabled');
      }
    });

    function updateNextButtonState(container) {
      const steps = container.querySelectorAll('.product__dropdown_wr');
      const nextButton = container.querySelector('.application_form__next_button');
      if (!steps.length || !nextButton) return;

      const allCompleted = [...steps].every(step => {
        if (step.classList.contains('product__dropdown_wr--heel') || 
            !step.querySelector('.product__dropdown_button')) return true;
        return step.querySelector('.product__dropdown_inner')?.classList.contains('super_done');
      });

      nextButton.disabled = !allCompleted;
      nextButton.classList.toggle('disabled-button', !allCompleted);
    }

    function setFollowingStepsDisabled(currentWrapper, disabled) {
      let next = currentWrapper.nextElementSibling;
      while (next) {
        if (next.classList.contains('product__dropdown_wr')) {
          next.classList.toggle('disabled', disabled);
        }
        next = next.nextElementSibling;
      }
    }
  });

  // Year select handler - EVENT DELEGATION
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-dropdown="year"] .select__select')) {
      const yearProperty = e.target.closest('.product__dropdown_wr').querySelector('.product__dropdown_value');
      if (yearProperty) {
        yearProperty.textContent = e.target.value;
      }
    }
    
    // Trunk label handler
    if (e.target.matches('[data-name="mats_set"] input')) {
      const labelTrunk = document.querySelector('.label_trunk');
      if (labelTrunk) {
        labelTrunk.classList.toggle('hidden', !e.target.classList.contains('input_trunk'));
      }
    }
  }, true);

  // Initialize trunk label
  const checkedInput = document.querySelector('[data-name="mats_set"] input:checked');
  const labelTrunk = document.querySelector('.label_trunk');
  if (checkedInput && labelTrunk) {
    labelTrunk.classList.toggle('hidden', !checkedInput.classList.contains('input_trunk'));
  }
})();